import React from 'react';
import styled from 'styled-components';

import { FONT } from '../../styles/color';
import { Bold, Medium } from './Text';
import { ORDER_STATUS, MALL_ACCOUNT } from '../../utils/constants';

const Container = styled.div`
	width: 100%;
	height: 140px;
	padding: 20px 30px;
	display: flex;
	flex-direction: row;
	box-sizing: border-box;
	border: 1px solid ${ FONT.mid };
	border-radius: 10px;
	cursor: pointer;
`;

const DateWrapper = styled.div`
	width: 190px;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;
	gap: 10px;
`;

const ItemWrapper = styled.div`
	height: 100%;
	flex-grow: 1;
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	gap: 20px;
`;

const ItemInfo = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
`;

const StatusWrapper = styled.div`
	width: 200px;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 10px;
`;

function renderStatusInfo(status, shipmentInfo) {
	switch(status) {
		case ORDER_STATUS.AWAITING_DEPOSIT.key:
			return (<Medium size="14px" color={ FONT.deep01 }>{
				`${MALL_ACCOUNT.BANK_NAME} ${MALL_ACCOUNT.ACCOUNT_NUMBER}`
			}</Medium>);
		case ORDER_STATUS.SHIPPED.key:
		case ORDER_STATUS.DELIVERED.key:
			return (
				<Medium size="14px" color={ FONT.deep01 }>
					{`${shipmentInfo.courierCompany} ${shipmentInfo.trackingNumber}`}
				</Medium>
			);
		default:
			return null;
	}
}

function Status(props) {
	if(props.isDetailView) {
		if(props.status === ORDER_STATUS.SHIPPED.key || props.status === ORDER_STATUS.DELIVERED.key) { 
			return (
				<StatusWrapper>
					<Medium size="14px" color={ FONT.deep01 }>
						{`${props.shipmentInfo.courierCompany} ${props.shipmentInfo.trackingNumber}`}
					</Medium>
				</StatusWrapper>
			);
		}
		return null;
	}

	return (
		<StatusWrapper>
			<Bold size="20px" color={ FONT.default }>{ORDER_STATUS[props.status].label}</Bold>
			{ renderStatusInfo(props.status, props.shipmentInfo) }
		</StatusWrapper>
	);
};


/* data for Order List View
props.orderData = {
	orderNumber: "20250725-123456",
	totalPriceAmout: 45000,
	orderStatus: AWAITING_DEPOSIT | PREPARING_FOR_SHIPMENT | SHIPPED | DELIVERED | CANCELLED,
	date: "2025-07-25",
	representName: "6.5oz 무지",
	representThumbnail: "image_url",
	productsCount: 3,
	courierCompany: "한진",
	trackingNumber : "123456789"
}
*/
function OrderItemForListView(props) {
	const data = props.data || {};

	return (
		<Container onClick={ props.onClick }>
			<DateWrapper>
				<Bold size="18px">{data.date}</Bold>
				<Medium size="16px">
					{`${data.orderNumber.split('-')[0]}-\n${data.orderNumber.split('-')[1]}`}
				</Medium>
			</DateWrapper>
			<ItemWrapper>
				<img
					src={ data.representThumbnail }
					alt="item_thumbnail"
					width='100px' height='100px'
					style= {{ borderRadius: '8px', display: 'block' }}
				/>
				<ItemInfo>
					<Medium size="16px" color={ FONT.default }>
						{ `${data.representName} 외 ${data.productsCount - 1}건` }
					</Medium>
					<Medium size="16px" color={ FONT.default }>{ data.totalPriceAmount.toLocaleString() }원</Medium>
				</ItemInfo>
			</ItemWrapper>
			<Status status={ data.orderStatus } isDetailView={ props.isDetailView } shipmentInfo = {{ courierCompany: data.courierCompany, trackingNumber: data.trackingNumber }}/>
		</Container>
  	);
};

// data for Order Detail View
/*
	{
		"productCode": "1",
		"productName": "6.5",
		"productThumbnail": "https://ywcnp.com",
		"quantity": 2,
		"price": 26000,
		"shippingFee": 4000
	}
*/
function OrderItemForDetailView(props) {
	const data = props.data || {};
	const extraInfo = props.extraInfo || {};

	return (
		<Container onClick={ props.onClick }>
			<ItemWrapper>
				<img
					src={ data.productThumbnail }
					alt="item_thumbnail"
					width='100px' height='100px'
					style= {{ borderRadius: '8px', display: 'block' }}
				/>
				<ItemInfo>
					<Medium size="16px" color={ FONT.default }>{
						`${data.productName} (${data.quantity}건)`
					}</Medium>
					<Medium size="16px" color={ FONT.default }>{ ((data.price + data.shippingFee) * data.quantity).toLocaleString() }원</Medium>
				</ItemInfo>
			</ItemWrapper>
			<Status status={ extraInfo.orderStatus } isDetailView={ true } shipmentInfo = {{ courierCompany: extraInfo.courierCompany, trackingNumber: extraInfo.trackingNumber }}/>
		</Container>
  	);
}

export default function OrderItem(props) {
	return (
		props.isDetailView ?
		<OrderItemForDetailView data={ props.data } extraInfo={ props.extraInfo } onClick={ props.onClick } /> :
		<OrderItemForListView data={ props.data } onClick={ props.onClick } />
  	);
}

